import { MaterialUICore } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const GenerateLink = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
